import { InjectionToken } from '@angular/core';

import type { PaymentMethodPickerBlockScenarioContent } from '@front-platform/content-builder';
import { IPaymentMethod } from '@config/payment-methods.config';

/** Runtime VM emitted by `PaymentMethodPickerBlock` data sources. */
export type PaymentMethodPickerBlockViewModel = {
  availablePaymentMethods: readonly IPaymentMethod[];
  orderFinalPrice: number | null;
  remainingMinutes: number | null;
  isRetryInProgress: boolean;
};

export type PaymentMethodPickerBlockScenarioViewModel = PaymentMethodPickerBlockScenarioContent;

export const PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM: PaymentMethodPickerBlockViewModel = {
  availablePaymentMethods: [],
  orderFinalPrice: null,
  remainingMinutes: null,
  isRetryInProgress: false,
};

export interface PaymentMethodPickerBlockDataSource {
  readonly vm$: import('rxjs').Observable<PaymentMethodPickerBlockViewModel>;
}

export const PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE =
  new InjectionToken<PaymentMethodPickerBlockDataSource>('PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE');
